import React from 'react';
import PropTypes from 'prop-types';
import ReactionAdditionalDataCellComponent from '@Components/Results/reactions/reaction-details/additional-data/reaction-additional-data-cell.component.jsx';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service'
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component.jsx';

export default class ReactionAdditionalDataContentsComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <table
        className={`rx-table rx-table--additional-info sticky-table-header ${ReactTableColumnSwitcherHelper.getTableClass(
          this.props.uniqueId,
          this.props.formatedData.headers,
        )}`}>
        <StickyTableHeaderComponent
          headers={this.props.formatedData.headers}
          showAllNonEmptyCols={this.props.showAllNonEmptyCols}
        />
        <tbody>
          {this.props.formatedData.rows.map((row, rI) => (
            <tr key={rI}>
              {this.props.formatedData.headers.map((cell, i) => (
                <ReactionAdditionalDataCellComponent
                  key={i}
                  row={row}
                  cell={cell}
                  index={i}
                  databaseId={this.props.databaseId}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

ReactionAdditionalDataContentsComponent.propTypes = {
  formatedData: PropTypes.object.isRequired,
  uniqueId: PropTypes.string.isRequired,
  databaseId: PropTypes.string.isRequired,
};
